import React from "react";
import GlobalPagination from "./GlobalPagination";
import { DropDownButton } from "./DropDownButton";
import { connect } from "react-redux";
import { setLauncherInstalled } from "../actions/launcherActions";

import lxwConstants from "../config/lexworkplace-constants";
import { IconExclamationMark } from "@tabler/icons-react";
const lexWorkplaceEditions = lxwConstants.lexWorkplaceEditions;

const ADVANCED_PREVIEW_LEARN_MORE_URL =
	"https://LexWorkplace.com/upgrade-to-advanced";

const calculateDaysRemaining = (expirationDate) => {
	if (!expirationDate) {
		return null;
	}
	const expiresAt = new Date(expirationDate).getTime();
	if (Number.isNaN(expiresAt)) {
		return null;
	}
	const msRemaining = expiresAt - Date.now();
	if (msRemaining <= 0) {
		return null;
	}
	return Math.ceil(msRemaining / (1000 * 60 * 60 * 24));
};

class Footer extends React.Component {
	render() {
		return (
			<div
				className="noselect"
				style={{
					backgroundColor: "var(--lw-light-grey-a)",
					borderTop: "1px solid",
					borderColor: "var(--lw-dark-grey)",
					display: "flex",
					lineHeight: "48px",
				}}
			>
				{" "}
				<div style={{ marginLeft: 8 }}>
					{this.props.footerLeftOverride ? (
						<div
							style={{
								marginLeft:
									this.props.footerLeftOverride.marginLeft ??
									0,
								fontFamily: "MainFont-Light",
								fontSize: 12,
							}}
						>
							{this.props.footerLeftOverride.text}
						</div>
					) : (
						<GlobalPagination />
					)}
				</div>
				<div
					style={{
						marginRight: 12,
						marginLeft: "auto",
						display: "flex",
					}}
				>
					{!this.props.launcherInstalled && (
						<div style={{ marginRight: 12, display: "flex" }}>
							<DropDownButton
								title="Launcher not installed!"
								pullRight
								dropup
								color="gold"
								iconComponent={
									<IconExclamationMark
										size={16}
										style={{ verticalAlign: "middle" }}
									/>
								}
								menuItems={[
									{
										text: "Download Launcher",
										onSelect: () =>
											//https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
											window.open(this.props.launcherURL),
									},
									{
										text: "Launcher is Already Installed (Activate Launcher)",
										onSelect: () => {
											this.props.setLauncherInstalled(
												true
											);
										},
									},
								]}
							/>
						</div>
					)}
					<div>
						<span>LexWorkplace™</span>{" "}
						{this.props.previewDaysRemaining != null ? (
							<span>
								<span
									style={{ fontFamily: "MainFont-SemiBold" }}
								>
									Advanced Preview
								</span>{" "}
								({this.props.previewDaysRemaining} Days
								Remaining){" "}
								<a
									href={ADVANCED_PREVIEW_LEARN_MORE_URL}
									target="_blank"
									rel="noopener noreferrer"
								>
									Learn More
								</a>
							</span>
						) : (
							<span style={{ fontFamily: "MainFont-SemiBold" }}>
								{this.props.lxwEditionDisplay}
							</span>
						)}
					</div>
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	const lxwEditionDisplay = lexWorkplaceEditions.options[
		state.user.lxwEdition
	]
		? lexWorkplaceEditions.options[state.user.lxwEdition].display
		: "";
	const previewDaysRemaining = calculateDaysRemaining(
		state.user.activeEditionPreview?.expirationDate
	);
	return {
		launcherInstalled: state.global.launcherInstalled,
		launcherURL: state.global.launcherURL,
		footerLeftOverride: state.global.footerLeftOverride,
		lxwEditionDisplay,
		previewDaysRemaining,
	};
};
export default connect(mapStateToProps, { setLauncherInstalled })(Footer);
